import * as React from 'react';
import type { OrderDetails } from '@/types';
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/atoms/dialog"
import { Button } from '@/components/atoms/button.tsx';
import { getOrderDetails } from '@/services.ts';
import { ShowOrderDetails } from './ShowOrderDetails';

export type ViewOrderProps = {
  isOpen: boolean
  onOpenChange: (open: boolean) => void
  orderId: string | null
}

export function ViewOrder(props: ViewOrderProps) {
  const [isLoading, setIsLoading] = React.useState(true);
  const [order, setOrder] = React.useState<OrderDetails | null>(null);

  React.useEffect(() => {
    if(props.orderId) {
      getOrderDetails(props.orderId as string).then(resp => {
        setOrder(resp);
        setIsLoading(false);
      });
    }
  }, [props.orderId]);

  const handleClose = () => {
    props.onOpenChange(false);
  }
  return (
    <Dialog open={props.isOpen} onOpenChange={props.onOpenChange}>
      <DialogContent className="sm:max-w-[800px]">
        <DialogHeader>
          <DialogTitle>View Order</DialogTitle>
        </DialogHeader>
        <ShowOrderDetails order={order} isLoading={isLoading} />
        <DialogFooter>
          <Button onClick={handleClose}>Close</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
